import { Routes, Route } from "react-router-dom";
import './styles/App.css';
import Layout from './pages/Layout';
import Work from './pages/Work';
import About from './pages/About';
import Dev from './pages/Dev';
import Footer from './components/Footer';
import Nav from './components/Nav';
import Sbs from './pages/Sbs';
import Voteally from './pages/Voteally';
import Craigslist from './pages/Craigslist';
import Whoami from './pages/Whoami';
import Innaorganic from "./pages/Innaorganic";
import PAT from './pages/PAT';
import Connector from './pages/Connector';
import ScrollToTop from './components/ScrollToTop';
import OpportunityMarketplace from "./pages/OpportunityMarketplace";

function App() {

  return (
    <div className="App">
      <Nav />
      <main>
        <ScrollToTop />
        <Routes>
            <Route path="/" element={<Layout />} />
            <Route index element={<Work />} />
            <Route path='/about' element={<About />} />
            <Route path='/dev' element={<Dev />} />
            <Route path='/work/Connector' element={<Connector />} />
            <Route path='/work/PAT' element={<PAT />} />
            <Route path='/work/sbs' element={<Sbs />} />
            <Route path='/work/voteally' element={<Voteally />} />
            <Route path='/work/craigslist' element={<Craigslist />} />
            <Route path='/work/whoami' element={<Whoami />} />
            <Route path='/work/innaorganic' element={<Innaorganic/>} />
            <Route path='/work/opportunitymarketplace' element={<OpportunityMarketplace/>} />
        </Routes>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
